import React from "react";

const GREEN = "#2E9B3A";
const GREEN_SOFT = "#E8F6EA";
const DARK = "#14291A";
const MUTED = "#4A5C50";
const BORDER = "rgba(46,155,58,0.12)";

const pageStyle = {
  width: "100%",
  maxWidth: "1100px",
  margin: "0 auto 32px",
  background: "#ffffff",
  padding: "40px 44px",
  boxSizing: "border-box",
  borderRadius: "20px",
  border: `1px solid ${BORDER}`,
  boxShadow: "0 8px 32px rgba(20,80,35,0.06)",
  position: "relative",
  overflow: "hidden",
};

const imagePageStyle = {
  ...pageStyle,
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "12px",
  width: "100%",
  alignItems: "end",
  marginBottom: "24px",
};

const imagePageStyle2 = {
  ...pageStyle,
  padding: "24px 28px",
  marginBottom: "24px",
};

const imageFrame = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const imageStyle = {
  width: "100%",
  maxWidth: "560px",
  maxHeight: "280px",
  objectFit: "contain",
  display: "block",
  margin: "0 auto",
  borderRadius: "14px",
};

const fiveColGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: "12px",
  width: "100%",
  alignItems: "end",
};

const screenshotStyle = {
  width: "100%",
  objectFit: "contain",
  display: "block",
  borderRadius: "10px",
  background: "#f4f8f5",
  border: `1px solid ${BORDER}`,
};

const headingStyle = {
  color: DARK,
  fontWeight: "800",
  margin: "0 0 8px",
  letterSpacing: "-0.4px",
  lineHeight: 1.25,
};

const textStyle = {
  color: MUTED,
  lineHeight: 1.65,
  fontSize: "14.5px",
  margin: "0 0 12px",
};

const serviceCardStyle = {
  borderRadius: "16px",
  padding: "24px 26px",
  marginBottom: "0",
  background: "linear-gradient(160deg, #ffffff 0%, #f6fbf7 100%)",
  border: `1px solid ${BORDER}`,
  boxShadow: "0 4px 18px rgba(31,91,42,0.05)",
  transition: "transform 0.22s ease, box-shadow 0.22s ease",
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

const featureListStyle = {
  margin: "6px 0 0",
  paddingLeft: "18px",
  lineHeight: 1.7,
  color: MUTED,
  fontSize: "13.5px",
};

function ServiceCard({ number, title, subtitle, children }) {
  return (
    <div
      style={serviceCardStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow =
          "0 10px 28px rgba(31,91,42,0.10)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 4px 18px rgba(31,91,42,0.05)";
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "14px",
          marginBottom: "12px",
        }}
      >
        <div
          style={{
            minWidth: "40px",
            height: "40px",
            borderRadius: "11px",
            background: `linear-gradient(145deg, ${GREEN}, #1f7a2a)`,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "800",
            fontSize: "15px",
            boxShadow: "0 4px 12px rgba(46,155,58,0.28)",
            flexShrink: 0,
          }}
        >
          {number}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <h2 style={{ ...headingStyle, fontSize: "17.5px", margin: 0 }}>
            {title}
          </h2>

          {subtitle && (
            <p
              style={{
                color: GREEN,
                fontSize: "13.5px",
                margin: "4px 0 0",
                fontWeight: "600",
                lineHeight: 1.4,
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
}

function ServiceGrid({ children }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        gap: "18px",
        alignItems: "stretch",
      }}
    >
      {children}
    </div>
  );
}

function SectionLabel({ children }) {
  return (
    <div
      style={{
        display: "inline-block",
        padding: "5px 14px",
        borderRadius: "50px",
        background: GREEN_SOFT,
        color: GREEN,
        fontWeight: "700",
        fontSize: "11.5px",
        letterSpacing: "0.4px",
        marginBottom: "10px",
      }}
    >
      {children}
    </div>
  );
}

function AIServices() {
  return (
    <div
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
        background:
          "radial-gradient(ellipse at 15% 0%, rgba(46,155,58,0.10), transparent 40%), radial-gradient(ellipse at 85% 10%, rgba(46,155,58,0.07), transparent 35%), #f0f5f1",
        minHeight: "100vh",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        boxSizing: "border-box",
      }}
    >
      {/* FULL-WIDTH BANNER: NO TOP OR SIDE GAP */}
      <section
        style={{
          width: "100%",
          margin: 0,
          padding: 0,
          border: "none",
          overflow: "hidden",
          lineHeight: 0,
          boxSizing: "border-box",
        }}
      >
        <img
          src="/ai-service-bannner.jpg"
          alt="LifeOnPlus AI Services Banner"
          style={{
            display: "block",
            width: "100%",
            maxWidth: "none",
            height: "auto",
            margin: 0,
            padding: 0,
            border: 0,
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </section>

      {/* ALL OTHER CONTENT */}
      <div
        style={{
          width: "100%",
          padding: "28px 14px 48px",
          boxSizing: "border-box",
        }}
      >
        {/* HERO */}
        <section style={{ ...pageStyle, padding: "48px 44px 52px" }}>
          <div
            style={{
              position: "absolute",
              width: "280px",
              height: "280px",
              borderRadius: "50%",
              background: "rgba(46,155,58,0.05)",
              top: "-120px",
              right: "-80px",
              pointerEvents: "none",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              textAlign: "center",
              maxWidth: "720px",
              margin: "0 auto",
            }}
          >
            <SectionLabel>LIFEONPLUS DIGITAL HEALTHCARE</SectionLabel>

            <h1
              style={{
                background:
                  "linear-gradient(100deg, #1a6e24, #2E9B3A, #4caf55)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: "clamp(26px, 3.2vw, 34px)",
                fontWeight: "900",
                margin: "0 0 12px",
                lineHeight: 1.18,
                letterSpacing: "-0.9px",
              }}
            >
              LifeOnPlus AI-Enabled Health Services
            </h1>

            <h2
              style={{
                color: DARK,
                fontSize: "clamp(15px, 1.7vw, 18px)",
                fontWeight: "600",
                margin: "0 0 16px",
                lineHeight: 1.4,
                opacity: 0.85,
              }}
            >
              Intelligent Digital Health Support — Anytime, Anywhere
            </h2>

            <p
              style={{
                ...textStyle,
                fontSize: "15px",
                lineHeight: 1.7,
                margin: 0,
                maxWidth: "620px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              LifeOnPlus brings AI-powered health-support tools together in one
              digital healthcare experience, helping members understand health
              information, organize healthy routines, and access useful guidance.
            </p>
          </div>
        </section>

        {/* INTRO IMAGES */}
        <section style={imagePageStyle}>
          <div style={imageFrame}>
            <img
              src="/ai-services/image2.jpeg"
              alt="LifeOnPlus Digital Health"
              style={imageStyle}
            />
          </div>

          <div style={imageFrame}>
            <img
              src="/ai-services/image3.jpeg"
              alt="AI Health Services"
              style={imageStyle}
            />
          </div>
        </section>

        {/* AI SERVICES + 1 */}
        <section style={pageStyle}>
          <div style={{ textAlign: "center", marginBottom: "28px" }}>
            <SectionLabel>AI HEALTH SERVICES</SectionLabel>
            <h1 style={{ ...headingStyle, fontSize: "26px", margin: 0 }}>
              Our AI Health Services
            </h1>
          </div>

          <ServiceCard
            number="1"
            title="AI Symptom Checker"
            subtitle="Understand your symptoms and get helpful guidance."
          >
            <p style={textStyle}>
              Describe your symptoms and receive AI-generated health information
              to help you understand possible areas of concern and decide when
              professional medical advice may be appropriate.
            </p>

            <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
              Key features
            </strong>

            <ul style={featureListStyle}>
              <li>Enter symptoms in simple language</li>
              <li>AI-assisted health information</li>
              <li>Guidance on possible next steps</li>
              <li>Helps prepare for a doctor consultation</li>
            </ul>
          </ServiceCard>
        </section>

        {/* SERVICES 2–4 */}
        <section style={pageStyle}>
          <ServiceGrid>
            <ServiceCard
              number="2"
              title="AI Diet Planner"
              subtitle="Personalized nutrition guidance for your goals."
            >
              <p style={textStyle}>
                Get AI-assisted meal and nutrition suggestions based on your
                stated goals, preferences and lifestyle information.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Personalized diet suggestions</li>
                <li>Meal-planning assistance</li>
                <li>Healthy food recommendations</li>
                <li>Goal-oriented nutrition guidance</li>
              </ul>
            </ServiceCard>

            <ServiceCard
              number="3"
              title="AI Mental Wellness Check"
              subtitle="A simple way to check in with your wellbeing."
            >
              <p style={textStyle}>
                Use an AI-supported wellness check to reflect on mood and
                everyday wellbeing and receive simple supportive suggestions.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Mood and wellbeing check-ins</li>
                <li>Simple self-reflection</li>
                <li>Lifestyle and wellbeing suggestions</li>
                <li>Encourages healthy daily habits</li>
              </ul>
            </ServiceCard>

            <ServiceCard
              number="4"
              title="AI Medication Advisor"
              subtitle="Understand your medicines and stay organized."
            >
              <p style={textStyle}>
                Get accessible information about medicines, along with
                medication reminders and general safety information.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Medicine information</li>
                <li>Dosage / reminder support</li>
                <li>Medication safety information</li>
                <li>Helps organize medication routines</li>
              </ul>
            </ServiceCard>
          </ServiceGrid>
        </section>

        {/* IMPORTANT + SERVICES 5–7 */}
        <section style={pageStyle}>
          <div
            style={{
              background: "linear-gradient(135deg, #eef9f0, #f8fcf8)",
              border: `1px solid ${BORDER}`,
              borderRadius: "12px",
              padding: "14px 18px",
              marginBottom: "22px",
              display: "flex",
              gap: "10px",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontSize: "16px", lineHeight: 1.4 }}>ℹ️</span>

            <p style={{ ...textStyle, margin: 0, fontSize: "13.5px" }}>
              <strong style={{ color: GREEN }}>Important:</strong> Medication
              information should complement—not replace—advice from a qualified
              healthcare professional.
            </p>
          </div>

          <ServiceGrid>
            <ServiceCard
              number="5"
              title="AI Report Summariser"
              subtitle="Turn complex health reports into clearer information."
            >
              <p style={textStyle}>
                Upload eligible health reports and receive an AI-assisted
                summary designed to help you understand important information
                before discussing it with your healthcare professional.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Upload health reports</li>
                <li>AI-assisted summarization</li>
                <li>Easy-to-understand explanations</li>
                <li>Helps prepare for doctor discussions</li>
              </ul>
            </ServiceCard>

            <ServiceCard
              number="6"
              title="AI First Aid Guide"
              subtitle="Step-by-step guidance for common emergencies."
            >
              <p style={textStyle}>
                Access AI-supported first-aid information for common situations
                while seeking appropriate professional or emergency assistance
                when required.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Step-by-step first-aid information</li>
                <li>Quick access during stressful situations</li>
                <li>Easy-to-follow guidance</li>
                <li>Supports emergency preparedness</li>
              </ul>

              <p
                style={{
                  ...textStyle,
                  marginTop: "10px",
                  marginBottom: 0,
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#8a5a00",
                }}
              >
                For genuine emergencies, contact emergency services rather than
                relying on an AI tool.
              </p>
            </ServiceCard>

            <ServiceCard
              number="7"
              title="AI Sleep Analyser"
              subtitle="Understand your sleep patterns and improve rest."
            >
              <p style={textStyle}>
                Use sleep information to receive AI-assisted observations and
                practical suggestions for healthier sleep habits.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Sleep-pattern analysis</li>
                <li>Sleep habit insights</li>
                <li>Personalized suggestions</li>
                <li>Supports better sleep routines</li>
              </ul>
            </ServiceCard>
          </ServiceGrid>
        </section>

        {/* SERVICES 8–9 */}
        <section style={pageStyle}>
          <ServiceGrid>
            <ServiceCard
              number="8"
              title="AI Calorie Estimator"
              subtitle="Estimate the calories in your meals."
            >
              <p style={textStyle}>
                Use AI-assisted estimation to understand the approximate
                calorie content of foods and meals.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Meal calorie estimation</li>
                <li>Food-based analysis</li>
                <li>Supports nutrition awareness</li>
                <li>Helps with personal health goals</li>
              </ul>

              <p
                style={{
                  ...textStyle,
                  marginTop: "8px",
                  marginBottom: 0,
                  fontSize: "13px",
                  fontStyle: "italic",
                }}
              >
                Estimates are approximate and can vary by ingredients, portion
                size and preparation.
              </p>
            </ServiceCard>

            <ServiceCard
              number="9"
              title="Photo & Report Scan"
              subtitle="Scan health information with your smartphone."
            >
              <p style={textStyle}>
                Upload photographs or supported health reports and receive
                AI-assisted insights and summaries.
              </p>

              <strong style={{ fontSize: "13px", color: DARK, display: "block" }}>
                Key features
              </strong>

              <ul style={featureListStyle}>
                <li>Photograph / upload reports</li>
                <li>AI-assisted information extraction</li>
                <li>Simplified report insights</li>
                <li>Convenient digital health documentation</li>
              </ul>
            </ServiceCard>
          </ServiceGrid>
        </section>

        {/* APP SCREENSHOTS */}
        <section style={imagePageStyle2}>
          <div style={{ textAlign: "center", marginBottom: "16px" }}>
            <SectionLabel>APP PREVIEWS</SectionLabel>
          </div>

          <div style={fiveColGridStyle}>
            <img
              src="/ai-services/image7.jpg"
              alt="LifeOnPlus AI Health Service – screen 1"
              style={screenshotStyle}
            />
            <img
              src="/ai-services/image8.jpg"
              alt="LifeOnPlus AI Health Service – screen 2"
              style={screenshotStyle}
            />
            <img
              src="/ai-services/image9.jpg"
              alt="LifeOnPlus AI Health Service – screen 3"
              style={screenshotStyle}
            />
            <img
              src="/ai-services/image10.jpg"
              alt="LifeOnPlus AI Health Service – screen 4"
              style={screenshotStyle}
            />
            <img
              src="/ai-services/image11.jpg"
              alt="LifeOnPlus AI Health Service – screen 5"
              style={screenshotStyle}
            />
          </div>
        </section>

        {/* PLATFORM OVERVIEW */}
        <section style={pageStyle}>
          <h1 style={{ ...headingStyle, fontSize: "24px" }}>
            One AI-Powered Health Platform
          </h1>

          <h2
            style={{
              color: GREEN,
              fontSize: "16.5px",
              margin: "0 0 14px",
              fontWeight: "700",
              lineHeight: 1.4,
            }}
          >
            From Symptoms to Wellness — LifeOnPlus Helps You Stay Informed
          </h2>

          <p style={textStyle}>
            With LifeOnPlus, members can access a range of AI-enabled tools
            designed around everyday health and wellness:
          </p>

          <div
            style={{
              margin: "20px 0",
              padding: "18px 22px",
              borderRadius: "14px",
              background: `linear-gradient(135deg, ${GREEN_SOFT}, #ffffff)`,
              border: `1px solid ${BORDER}`,
              textAlign: "center",
              fontSize: "14.5px",
              fontWeight: "700",
              color: GREEN,
              letterSpacing: "0.2px",
              lineHeight: 1.5,
            }}
          >
            Understand → Plan → Track → Learn → Take Action → Connect with Care
          </div>

          <p style={{ ...textStyle, marginBottom: 0 }}>
            The AI services work alongside the broader LifeOnPlus digital
            healthcare ecosystem, including emergency services, health
            information, doctor consultation and preventive-health services.
          </p>
        </section>

        {/* DESIGNED AROUND YOU */}
        <section style={pageStyle}>
          <h1 style={{ ...headingStyle, fontSize: "24px", marginBottom: "20px" }}>
            Designed Around You
          </h1>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: "14px",
            }}
          >
            {[
              {
                icon: "🩺",
                title: "Understand",
                desc: "Get easier-to-understand health information.",
              },
              {
                icon: "🥗",
                title: "Plan",
                desc: "Create healthier nutrition and lifestyle routines.",
              },
              {
                icon: "💊",
                title: "Organize",
                desc: "Keep track of medication-related information and reminders.",
              },
              {
                icon: "📄",
                title: "Simplify",
                desc: "Make health reports easier to understand.",
              },
              {
                icon: "😴",
                title: "Improve",
                desc: "Learn more about sleep and everyday wellbeing.",
              },
              {
                icon: "🚑",
                title: "Prepare",
                desc: "Access first-aid and emergency-preparedness information.",
              },
              {
                icon: "❤️",
                title: "Connect",
                desc: "Use digital information as a starting point for conversations with healthcare professionals.",
              },
            ].map((item) => (
              <div
                key={item.title}
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-start",
                  padding: "16px 18px",
                  borderRadius: "14px",
                  background: "linear-gradient(160deg, #ffffff, #f6fbf7)",
                  border: `1px solid ${BORDER}`,
                  boxShadow: "0 2px 10px rgba(31,91,42,0.04)",
                }}
              >
                <span
                  style={{
                    fontSize: "22px",
                    lineHeight: 1,
                    flexShrink: 0,
                    marginTop: "1px",
                  }}
                >
                  {item.icon}
                </span>

                <div>
                  <h3
                    style={{
                      ...headingStyle,
                      fontSize: "15px",
                      margin: "0 0 4px",
                    }}
                  >
                    {item.title}
                  </h3>

                  <p style={{ ...textStyle, margin: 0, fontSize: "13.5px" }}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* AI + HUMAN + DISCLAIMER */}
        <section style={pageStyle}>
          <h1 style={{ ...headingStyle, fontSize: "24px" }}>
            AI + Human Healthcare
          </h1>

          <h2
            style={{
              color: GREEN,
              fontSize: "16.5px",
              margin: "0 0 14px",
              fontWeight: "700",
              lineHeight: 1.4,
            }}
          >
            Technology Supports Healthcare. Professionals Remain Essential.
          </h2>

          <p style={textStyle}>
            LifeOnPlus positions these tools as AI-assisted health and wellness
            services, rather than presenting AI output as a medical diagnosis or
            replacement for a doctor.
          </p>

          <p style={textStyle}>
            This distinction is particularly important for services involving
            symptoms, medicines, medical reports or emergency situations. Current
            FDA guidance distinguishes different types of health software
            according to their intended use, and AI-enabled medical technologies
            can have different regulatory requirements depending on what they do.
          </p>

          <p style={{ ...textStyle, marginBottom: "28px" }}>
            WHO also emphasizes safety, transparency, accountability and
            appropriate governance when AI is used in healthcare.
          </p>

          <h2 style={{ ...headingStyle, fontSize: "20px", marginBottom: "12px" }}>
            Website Disclaimer
          </h2>

          <div
            style={{
              background: "linear-gradient(145deg, #fffdf6, #fff8e6)",
              border: "1px solid #e8d9a8",
              padding: "18px 20px",
              borderRadius: "14px",
            }}
          >
            <p
              style={{
                ...textStyle,
                margin: 0,
                fontWeight: "600",
                fontSize: "13.5px",
                lineHeight: 1.65,
                color: "#5c4a20",
              }}
            >
              Important: LifeOnPlus AI-enabled services are intended to provide
              informational, educational and supportive health and wellness
              assistance. AI-generated information is not a medical diagnosis
              and should not replace consultation, diagnosis or treatment by a
              qualified healthcare professional. In an emergency or when
              experiencing serious symptoms, seek appropriate emergency medical
              assistance immediately.
            </p>
          </div>
        </section>

        {/* SUGGESTED LAYOUT */}
        <section style={pageStyle}>
          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            <SectionLabel>WEBSITE STRUCTURE</SectionLabel>

            <h1 style={{ ...headingStyle, fontSize: "24px", margin: 0 }}>
              Suggested Website Layout
            </h1>
          </div>

          <p style={{ ...textStyle, textAlign: "center" }}>
            A clean structure for the LifeOnPlus AI Services page:
          </p>

          <div
            style={{
              margin: "20px 0 12px",
              padding: "28px 24px",
              borderRadius: "16px",
              background: `linear-gradient(135deg, ${GREEN_SOFT}, #ffffff)`,
              border: `1px solid ${BORDER}`,
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: GREEN,
                letterSpacing: "0.5px",
                margin: "0 0 8px",
                textTransform: "uppercase",
              }}
            >
              Hero Banner
            </p>

            <h2
              style={{
                color: DARK,
                fontSize: "18px",
                margin: 0,
                fontWeight: "800",
                lineHeight: 1.35,
              }}
            >
              AI-Powered Health. Smarter Support. Better Decisions.
            </h2>
          </div>

          <div
            style={{
              textAlign: "center",
              color: GREEN,
              fontSize: "18px",
              margin: "8px 0 16px",
              opacity: 0.7,
            }}
          >
            ↓
          </div>

          <h2
            style={{
              ...headingStyle,
              textAlign: "center",
              fontSize: "18px",
              marginBottom: "6px",
            }}
          >
            9 AI Service Cards
          </h2>

          <p
            style={{
              ...textStyle,
              textAlign: "center",
              marginBottom: "18px",
              fontSize: "13.5px",
            }}
          >
            Each with icon + short description
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "12px",
            }}
          >
            {[
              {
                icon: "🩺",
                title: "AI Symptom Checker",
                note: "AI + medical cross",
              },
              {
                icon: "🥗",
                title: "AI Diet Planner",
                note: "Healthy food",
              },
              {
                icon: "🧠",
                title: "AI Mental Wellness",
                note: "Brain / wellness",
              },
              {
                icon: "💊",
                title: "AI Medication Advisor",
                note: "Medicine / capsule",
              },
              {
                icon: "📄",
                title: "AI Report Summariser",
                note: "Medical report",
              },
              {
                icon: "🆘",
                title: "AI First Aid Guide",
                note: "First-aid kit",
              },
              {
                icon: "🌙",
                title: "AI Sleep Analyser",
                note: "Moon / sleep",
              },
              {
                icon: "🔥",
                title: "AI Calorie Estimator",
                note: "Food / calorie",
              },
              {
                icon: "📷",
                title: "Photo & Report Scan",
                note: "Phone + document",
              },
            ].map((item) => (
              <div
                key={item.title}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  padding: "18px 14px",
                  borderRadius: "14px",
                  background: "linear-gradient(160deg, #ffffff, #f6fbf7)",
                  border: `1px solid ${BORDER}`,
                  gap: "6px",
                }}
              >
                <span style={{ fontSize: "26px", lineHeight: 1 }}>
                  {item.icon}
                </span>

                <h3 style={{ ...headingStyle, fontSize: "13.5px", margin: 0 }}>
                  {item.title}
                </h3>

                <p
                  style={{
                    ...textStyle,
                    margin: 0,
                    fontSize: "12px",
                    opacity: 0.8,
                  }}
                >
                  {item.note}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default AIServices;
